package api

import kotlinx.serialization.Serializable


@Serializable
data class StateResponse(val nextPath: String, val placeCode: String? = null)